import classnames from 'classnames';
import $ from 'jquery';
import React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { Button, Card, CardBody, CardTitle, Form } from 'reactstrap';
import { Dispatch } from 'redux';
import { login } from '../../../stores/auth/actionCreators';
import { isLoading } from '../../../stores/navigation/selectors';
import { task, url, application, queryString } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import FormInput from '../../common/FormInput';
import { LoadingButton } from '../../navigation/LoadingButton';
import './LoginPage.scss';

export interface Props extends RouteComponentProps, LocalizeContextProps {
    isLoading: boolean;

    login: (form: State) => void;

    task: string;
    url: string;
    application: string;
    queryString: string;
}

export interface State {
    email: string;
    password: string;
    remember_me: boolean;
    task: string;
    url: string;
    application: string;
    queryString: string;
}

class LoginDialog extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            remember_me: false,
            task: props.task,
            url: props.url,
            application: props.application,
            queryString: props.queryString
        };
    }

    public componentDidMount() {
        $('#emailInput').focus();
    }

    public handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            [event.target.name]: event.target.type === 'checkbox' ?
                event.target.checked : event.target.value,
            // tslint:disable-next-line:no-any
        } as any);
    }

    public render() {
        const t = this.props.translate;
        return (
            <Card >
                <CardBody className="p-0">
                    <CardTitle tag="h3" className="py-3 px-5">{t('login.header.login')}</CardTitle>

                    <Form className="p-5">
                        <FormInput
                            id="emailInput"
                            name="email"
                            fullName={t('login.field.email') as string}
                            type="text"
                            value={this.state.email}
                            onChange={this.handleInputChange}
                        />
                        <FormInput
                            name="password"
                            fullName={t('login.field.password') as string}
                            type="password"
                            value={this.state.password}
                            onChange={this.handleInputChange}
                        />
                        <FormInput
                            name="remember_me"
                            fullName={t('login.field.rememberMe') as string}
                            type="checkbox"
                            checked={this.state.remember_me}
                            onChange={this.handleInputChange}
                        />
                        <Link
                            to={{
                                pathname: '/forgot-password',
                                state: { from: this.props.location },
                            }}
                        >
                            {t('login.link.forgotPassword')}
                        </Link>
                        <LoadingButton
                            fixedWidth={true}
                            color="primary"
                            className={classnames('float-right', 'loginBtn','mb-3')}
                            type="submit"
                            loading={this.props.isLoading}
                            onSubmit={(e) => { e.preventDefault(); this.props.login(this.state); }}
                            onClick={(e) => { e.preventDefault(); this.props.login(this.state); }}
                        >
                            {!this.props.isLoading ? t('login.button.signIn') : t('login.button.signingIn')}
                        </LoadingButton>
                    </Form>
                </CardBody>
            </Card>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    isLoading: isLoading(state),
    url: url(state),
    task: task(state),
    application: application(state),
    queryString: queryString(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    login: (state: State) => dispatch(login(state.email, state.password, state.remember_me, 
        state.task, state.url, state.application, state.queryString)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(LoginDialog)));
